import { APP_VERSION } from '@/_constants/analytics';
import { APP_NAMESPACE } from '@/_constants/app-namespace';

const MS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
const DAYS_IN_WEEK = 7;
const DAYS_IN_TWO_WEEKS = 14;
const DAYS_IN_MONTH = 30;

const EXPIRES = {
  hour: MS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR,
  week:
    MS_IN_SECOND *
    SECONDS_IN_MINUTE *
    MINUTES_IN_HOUR *
    HOURS_IN_DAY *
    DAYS_IN_WEEK,
  twoWeeks:
    MS_IN_SECOND *
    SECONDS_IN_MINUTE *
    MINUTES_IN_HOUR *
    HOURS_IN_DAY *
    DAYS_IN_TWO_WEEKS,
  month:
    MS_IN_SECOND *
    SECONDS_IN_MINUTE *
    MINUTES_IN_HOUR *
    HOURS_IN_DAY *
    DAYS_IN_MONTH,
};

export const DEFAULT_API_CACHE_PARAMS = {
  storageCacheName: `${APP_NAMESPACE}__${APP_VERSION}__requests-cache`,
  debug: true,
  disabledCache: true,
  expires: EXPIRES.twoWeeks,
};
